// Active le JavaScript (accessibilité progressive)
document.body.classList.add('js-enabled');

function closeMenu() {
    jQuery('.MenuFullWidth__content-wrapper').hide();
    jQuery('.close_menu').hide();
    jQuery('body').removeClass('burger-activated');
    jQuery('html').removeClass('menu-open');
    jQuery('.MenuFullWidth').removeClass('submenu-open');
    jQuery('.MenuFullWidth__sub-menu').removeClass('MenuFullWidth__sub-menu--active has-scroll');
}

/**
 * Ouverture du menu burger
 */
function openMenu() {
    jQuery('body').addClass('burger-activated');
    jQuery('.close_menu').show();
    jQuery('.MenuFullWidth__content-wrapper').show();
    jQuery('html').addClass('menu-open');
}

// Événements d'ouverture/fermeture
jQuery('body').on('click', '.button--menu', openMenu);
jQuery('.close_menu').on('click', closeMenu);

/**
 * Affiche la flèche de scroll seulement si la liste déborde.
 */
function updateSubmenuScrollHint($submenu) {
    const items = $submenu.find('.MenuFullWidth__sub-menu-items').get(0);
    if (!items) {
        $submenu.removeClass('has-scroll');
        return;
    }
    $submenu.toggleClass('has-scroll', items.scrollHeight > items.clientHeight + 1);
}

/**
 * Navigation vers un sous-menu
 */
jQuery('body').on('click', '.menu .menu-item-has-children > a', function (e) {
    e.preventDefault();
    const $link = jQuery(this);
    const $submenu = $link.next('.MenuFullWidth__sub-menu');
    const $wrapper = jQuery('.MenuFullWidth__content-wrapper');
    
    // Animation de transition vers le sous-menu
    $wrapper.fadeOut(400);
    
    setTimeout(function() {
        jQuery('.MenuFullWidth').addClass('submenu-open');
        $submenu.addClass('MenuFullWidth__sub-menu--active');
        $wrapper.fadeIn(400);
        requestAnimationFrame(function() {
            updateSubmenuScrollHint($submenu);
        });
    }, 450);
});

/**
 * Retour au menu principal depuis un sous-menu
 */
jQuery('.btn-return').on('click', function () {
    const $wrapper = jQuery('.MenuFullWidth__content-wrapper');
    
    // Animation de retour au menu principal
    $wrapper.fadeOut(400);
    
    setTimeout(function() {
        jQuery('.MenuFullWidth').removeClass('submenu-open');
        jQuery('.MenuFullWidth__sub-menu').removeClass('MenuFullWidth__sub-menu--active has-scroll');
        $wrapper.fadeIn(400);
    }, 450);
});

/**
 * Gestion affichage conditionnel boutons connexion/déconnexion
 */
jQuery(document).ready(function($) {
    // Attendre que Elementor soit complètement chargé
    setTimeout(function() {
        const isLoggedIn = $('body').hasClass('logged-in');
        const btnLogin = $('#btn-login');
        const btnLogout = $('#btn-logout');
        const btnMyaccount = $('#btn-myaccount');
        
        if (isLoggedIn) {
            // Utilisateur connecté : afficher déconnexion, cacher connexion
            btnLogin.removeClass('is-visible');
            btnMyaccount.addClass('is-visible');
            
            // Mettre à jour le lien de déconnexion avec l'URL correcte
            // L'URL de déconnexion est générée par PHP et injectée dans le DOM
            if (typeof amobfLogoutUrl !== 'undefined') {
                btnLogout.attr('href', amobfLogoutUrl);
            }
        } else {
            // Utilisateur déconnecté : afficher connexion, cacher déconnexion
            btnLogin.addClass('is-visible');
            btnMyaccount.removeClass('is-visible');
        }
    }, 500); // Délai de 500ms pour laisser Elementor charger
}); 